import React, { useContext } from "react";
import RegisterOscContext from "../../context/RegisterContext";


export const RegisterProgress = () => {

    const {step} = useContext(RegisterOscContext)
  
    return(
        <>
        <div className="grid gap-2 md:gap-0 grid-cols-2 md:grid-cols-7 font-semibold mt-10">
            <div className="col-span-1">Dados Gerais</div>
            <div className="col-span-1 md:text-center">Contato</div>
            <div className="md:col-span-2 col-span-1 md:text-center">Atuação e Público alvo</div>
            <div className="md:col-span-2 col-span-1 md:text-center">Estrutura Organização</div>
            <div className="col-span-1 md:text-right">Logo e descrição</div>
        </div>
        <div className=" hidden md:grid grid-cols-7 border mt-1 mb-6">
            <div className={`col-span-1 h-1.5 ${step >= 1 && 'bg-primary-dark'}`}></div>
            <div className={`col-span-1 h-1.5 ${step >= 2 && 'bg-primary-dark'}`}></div>
            <div className={`col-span-2 h-1.5 ${step >= 3 && 'bg-primary-dark'}`}></div>
            <div className={`col-span-2 h-1.5 ${step >= 4 && 'bg-primary-dark'}`}></div>
            <div className={`col-span-1 h-1.5 ${step >= 5 && 'bg-primary-dark'}`}></div>
        </div>

        </>
    )
}


